<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<img alt="Lovesick_Frontcover_Titleonly.png" class="calibre2" src="cover.jpeg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CoverImage.vue?35e1f4e8